import React, { useState } from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";

const SpecialSlots = ({
  superAdmin,
  dates,
  setDates,
  selectedDate,
  setSelectedDate,
}) => {
  const [days, setDays] = useState([
    "06-02-2018",
    "19-11-2021",
    "25-07-2013",
    "14-03-2020",
    "01-09-2016",
    "22-12-2009",
    "30-04-2024",
    "17-08-2011",
    "09-05-2019",
    "28-10-2015",
  ]);

  const [selectedDay, setSelectedDay] = useState(["06-02-2018"]);
  const [realDay, setRealDay] = useState("06-02-2018");
  const [showSchedule, setShowSchedule] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [index_, setIndex_] = useState(0);

  const handleDayClick = (day, ind) => {
    setSelectedDate(day);
    setIndex_(ind);
    setRealDay(day);
    setSchedule([]);
    setShowSchedule(false);
  };

  const handleToggle = () => {
    setShowSchedule((prev) => !prev);
  };

  console.log("schedule", schedule);

  const handleSubmit = () => {
    const updatedArray = [...schedule, realDay];
    setSelectedDay(updatedArray);
  };

  return (
    <div className="dashRightView">
      <div className="slot-container">
        <div className="days-scroll">
          {dates?.map((day, ind) => {
            return (
              <button
                key={ind}
                className={`f2 fs-sm-10 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 day-btn ${
                  selectedDate == day?.id ? "active" : ""
                }`}
                onClick={() => handleDayClick(day?.id, ind)}
              >
                {day?.for_date}
              </button>
            );
          })}
        </div>

        {!superAdmin && (
          <div className="d-flex ac-je my-3">
            <button className="import-btn">import</button>
          </div>
        )}

        {dates?.length > 0 && (
          <div className="Oversall-box-special d-flex ac-jb">
            <div className="d-flex ae-js gap-3 my-4">
              <h3 className="f3 fs-sm-19 fs-md-18 fs-lg-18 fs-xl-22 fs-xxl-27">
                {dates?.[index_]?.for_date} Schedule
              </h3>
              {/* <div
                className="gap-3 d-flex toggle-btn"
                onClick={() => handleToggle(selectedDay)}
                style={{ marginBottom: "35px" }}
              >
                {dates?.[index_]?.toggle ? (
                  <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                ) : (
                  <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                )}
              </div> */}
              <div
                className="gap-3 d-flex toggle-btn"
                onClick={() => handleToggle(selectedDay)}
                style={{ width: 89, height: 50, overflow: "hidden" }}
              >
                {dates?.[index_]?.toggle ? (
                  <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                ) : (
                  <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                )}
              </div>
            </div>

            {dates?.[index_]?.toggle && (
              <div className="schedule-box ">
                <div className="time-inputs">
                  <div>
                    <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                      Start Time (mins)
                    </label>
                    <input
                      type="time"
                      value={dates?.[index_]?.start_time}
                      onChange={(e) => {
                        handleToggle(index_, "start_time", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                      End Time (mins)
                    </label>
                    <input
                      type="time"
                      value={dates?.[index_]?.end_time}
                      onChange={(e) => {
                        handleToggle(index_, "end_time", e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SpecialSlots;
